/* Pellvara — Klaviyo email capture handler */

(function () {
  function subscribeEmail(email, source) {
    fetch('https://a.klaviyo.com/client/subscriptions/?company_id=RR4wvq', {
      method: 'POST',
      headers: {
        'content-type': 'application/json',
        'revision': '2024-10-15'
      },
      body: JSON.stringify({
        data: {
          type: 'subscription',
          attributes: {
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  email: email
                }
              }
            },
            custom_source: source
          },
          relationships: {
            list: {
              data: {
                type: 'list',
                id: 'UmJkTZ'
              }
            }
          }
        }
      })
    }).catch(function () {});
  }

  function initForm(formEl, source) {
    if (!formEl) return;
    var successEl = formEl.parentElement.querySelector('.pellvara-form-success');

    formEl.addEventListener('submit', function (e) {
      e.preventDefault();
      var emailInput = formEl.querySelector('input[type="email"]');
      if (!emailInput || !emailInput.value) return;

      var email = emailInput.value.trim();
      if (!email) return;

      subscribeEmail(email, source);

      formEl.style.display = 'none';
      if (successEl) {
        successEl.style.display = 'block';
        successEl.textContent = "You're on the list. We'll be in touch.";
      } else {
        var msg = document.createElement('p');
        msg.textContent = "You're on the list. We'll be in touch.";
        msg.style.cssText = 'color:#B8924B;font-weight:600;font-size:15px;text-align:center;margin-top:12px;';
        formEl.parentElement.appendChild(msg);
      }
    });
  }

  function initForms() {
    var hero       = document.getElementById('pellvara-form-hero');
    var secondary  = document.getElementById('pellvara-form-secondary');
    var article    = document.getElementById('pellvara-form-article');
    var expertqa   = document.getElementById('pellvara-form-expert-qa');

initForm(hero,      'homepage_hero');
    initForm(secondary, 'homepage_secondary');
    initForm(article,   'article_end');
    initForm(expertqa,  'expert_qa_end');
  }

  /* Guard: defer scripts can run after DOMContentLoaded has already fired */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initForms);
  } else {
    initForms();
  }
})();
